import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { cn } from '@repo/utils'

import { notificationsRemove } from '../../actions'
import NotificationsContainer from '../../components/NotificationsContainer'
import NotificationSchema from '../../schemas/NotificationSchema'

import styles from './index.css'

class NotificationsZone extends PureComponent {
  onRemoveNotification = (notification) => {
    this.props.notificationsRemove(notification.id)
  }

  render() {
    const { className, dismissAfter, initialDelay, notifications } = this.props
    return (
      <NotificationsContainer
        className={cn(styles.wrapper, className)}
        notifications={notifications.map((n) => ({
          dismissAfter,
          initialDelay,
          ...n,
        }))}
        onRemoveNotification={this.onRemoveNotification}
      />
    )
  }
}

NotificationsZone.propTypes = {
  notifications: PropTypes.arrayOf(NotificationSchema).isRequired,
  notificationsRemove: PropTypes.func.isRequired,

  className: PropTypes.string,
  dismissAfter: PropTypes.number,
  initialDelay: PropTypes.number,
}

NotificationsZone.defaultProps = {
  className: '',
  dismissAfter: 3500,
  initialDelay: 0,
}

export class Pure extends NotificationsZone {}

export default connect(({ notifications: { notifications } }) => ({ notifications }), {
  notificationsRemove,
})(NotificationsZone)
